import React from 'react'
import Button from '@bt-react/components/Button'
import Icon, { IconType } from '@bt-react/components/Icon'
import { TwilioDocSupportScreenProps } from './types'
import { status } from '@bt-react/constants'
import style from './TwilioDocSupportScreen.module.scss'

const TwilioDocSupportScreen: React.FC<TwilioDocSupportScreenProps> = props => {

  const isGoingLiveResetButtonDisabled = !props.isGoingLive || (props.status && props.status === status.GOING_LIVE)

  return <div className={style['twilioDocSupportScreen']}>
    <h2 className={style['twilioDocSupportScreen-header']}><Icon name={IconType.iconName.danger} colour={IconType.colour.danger} /> Twilio UI Doc</h2>
    <h4>Gig Information</h4>
    <ul className={style['doc']}>
      <li className={style['docEntry']}>
        <div>
          <span className={style['docVal']}>Gig Status:</span>
          <span className={style['docVal--emphasize']}>{props.status}</span>
        </div>
      </li>
      <li className={style['docEntry']}>
        <div>
          <span className={style['docVal']}>Time gig status changed to LIVE:</span>
          <span className={style['docVal--emphasize']}>{props.liveDateTime || 'Not live yet'}</span>
        </div>
      </li>
      <li className={style['docEntry']}>
        <div>
          <span className={style['docVal']}>Current Media Type:</span>
          <span className={style['docVal--emphasize']}>{props.mediaType}</span>
        </div>
      </li>
    </ul>
    <h4>Actions</h4>
    {
      <div>
      <Button
        dataBdd='reset-going-live-btn'
        onClick={props.resetGoingLive}
        text='Reset the live requested spinner'
        disabled={isGoingLiveResetButtonDisabled}
        color={isGoingLiveResetButtonDisabled ? IconType.colour.londonGrey : IconType.colour.danger}
      />
      <Button
        dataBdd='reset-going-live-btn'
        onClick={() => props.setBookingStatus('UPCOMING')}
        text='Set booking status to upcoming'
        color={isGoingLiveResetButtonDisabled ? IconType.colour.londonGrey : IconType.colour.danger}
      />
      <Button
        dataBdd='reset-going-live-btn'
        onClick={() => props.setBookingStatus('LIVE-ENABLED')}
        text='Set booking status to live enabled'
        color={isGoingLiveResetButtonDisabled ? IconType.colour.londonGrey : IconType.colour.danger}
      />
      <Button
        dataBdd='reset-going-live-btn'
        onClick={() => props.setBookingStatus('GOING-LIVE')}
        text='Set booking status to going live'
        color={isGoingLiveResetButtonDisabled ? IconType.colour.londonGrey : IconType.colour.danger}
      />
      <Button
        dataBdd='reset-going-live-btn'
        onClick={() => props.setBookingStatus('PRE-ROLL-INTERSTITIAL')}
        text='Set booking status to preroll interstitial'
        color={isGoingLiveResetButtonDisabled ? IconType.colour.londonGrey : IconType.colour.danger}
      />
      <Button
        dataBdd='reset-going-live-btn'
        onClick={() => props.setBookingStatus('LIVE')}
        text='Set booking status to live'
        color={isGoingLiveResetButtonDisabled ? IconType.colour.londonGrey : IconType.colour.danger}
      />
      <Button
        dataBdd='reset-going-live-btn'
        onClick={() => props.setBookingStatus('COMPLETE')}
        text='Set booking status to complete'
        color={isGoingLiveResetButtonDisabled ? IconType.colour.londonGrey : IconType.colour.danger}
      />
      <Button
        dataBdd='reset-going-live-btn'
        onClick={() => props.setBookingStatus('OVERRUN')}
        text='Set booking status to complete'
        color={isGoingLiveResetButtonDisabled ? IconType.colour.londonGrey : IconType.colour.danger}
      />
      </div>
    }
  </div>

}

export default TwilioDocSupportScreen
